import React from 'react';

import { Image } from '@/core/Image/Image';
import { P } from '@/core/tamagoshiTailwind/components/Typography/Typography';

import { items } from './data/data.default';

const ReassuranceTitledList = React.memo(() => (
  <div className="flex flex-col items-center justify-center">
    <div
      className="grid w-full grid-cols-1 gap-l rounded-container
        bg-foundation-inverted p-m tablet:grid-cols-2 tablet:px-l tablet:py-m
        desktop:grid-cols-4 desktop:gap-m desktop:px-xxxl desktop:py-m"
    >
      {items.map(({ icon, desc }) => (
        <div key={desc} className="flex items-center gap-m">
          <div
            className="flex size-[56px] min-w-[56px] items-center justify-center
              rounded-full bg-foundation-primary"
          >
            <Image src={icon} alt={desc} height={32} width={32} />
          </div>
          <P scale="body2" weight="semibold" className="desktop:max-w-[210px]">
            {desc}
          </P>
        </div>
      ))}
    </div>
  </div>
));

ReassuranceTitledList.displayName = 'ReassuranceTitledList';

export default ReassuranceTitledList;
